<template>
    <div>
        <ul class="list-unstyled multi-steps">
            <li :class="{'is-active':completed_steps.includes(1),'current':step===1}">
                <a href="#" @click="$emit('select_step',1)">
                    <fa :icon="fas.faUser" class="icon-circle"/>
                    <fa v-if="completed_steps.includes(1)" :icon="fas.faCheckCircle" class="progress-check"></fa>
                    {{ $t('label.profile') }}
                </a>
            </li>
            <li :class="{'is-active':completed_steps.includes(2),'current':step===2}">
                <a href="#" @click="$emit('select_step',2)">
                    <fa :icon="fas.faUsers" class="icon-circle"/>
                    <fa v-if="completed_steps.includes(2)" :icon="fas.faCheckCircle" class="progress-check"></fa>
                    {{ $t('label.driver') }}
                </a>

            </li>
            <li :class="{'is-active':completed_steps.includes(3),'current':step===3}">
                <a href="#" @click="$emit('select_step',3)">
                    <fa :icon="fas.faCar" class="icon-circle"/>
                    <fa v-if="completed_steps.includes(3)" :icon="fas.faCheckCircle" class="progress-check"></fa>
                    {{ $t('label.vehicle') }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import {fas} from "@fortawesome/free-solid-svg-icons";
    export default {
        name: "SetupStatus",
        props: {
            step: {
                type: Number,
                default: 1
            },
            completed_steps:{
                type: Array,
                default: () => {
                    return [];
                },
            }
        },
        data() {
            return {
                current_step:1
            }
        },
        computed: {
            fas() {
                return fas;
            },
        },
        watch:{
            completed_steps: function () {
                this.renderSteps();
            }
        },
        mounted() {

        },
        methods:{
            renderSteps(){
                if(!this.completed_steps.includes(1)){
                    this.current_step = 1;
                }else if(!this.completed_steps.includes(2)){
                    this.current_step = 2;
                }else if(!this.completed_steps.includes(3)){
                    this.current_step = 3;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    // Start Progress Steps
    .multi-steps > li.is-active:before,
    .multi-steps > li.is-active ~ li:before {
        /*content: counter(stepNum);*/
        font-family: inherit;
        font-weight: 900;
        /*color: #888888;*/
    }

    .multi-steps {
        display: table;
        table-layout: fixed;
        width: 100%;
    }
    .multi-steps > li {
        counter-increment: stepNum;
        text-align: center;
        display: table-cell;
        position: relative;
        color: #888888;
        font-size: 13px;
        font-weight: bold;
        top:3px;
        transition: transform 0.3s ease-in-out;
    a {
        color: #888888;
    }
    }

    .multi-steps > li.is-active {
        color: green;

    a {
        color:green;
    }

    &:before {
         border-color:green !important;
         background-color: #6fcc6f31 !important;
     }
    }

    .multi-steps > li:before {
        /*content: "\2714";*/
        content: "";
        display: block;
        position: relative;
        margin: 0 auto 6px;
        background-color: #ECF0F5;
        width: 40px;
        height: 40px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
        border-width: 2px;
        border-style: solid;
        border-radius: 50%;
        z-index: 1;
    }
    .multi-steps > li:after {
        content: "";
        height: 2px;
        width: 60%;
        background-color: #888888;
        position: absolute;
        top: 20px;
        left: 50%;
        margin-left: 20%;
        z-index: 0;
    }
    .multi-steps > li.is-active:after{
        background-color: green;
    }
    .multi-steps > li:last-child:after {
        display: none;
    }
    .multi-steps > li.is-active:before {
        background-color: #ECF0F5;
        border-color: #888888;
    }
    .multi-steps > li.is-active ~ li {
        /*color: #888888;*/
    }
    .multi-steps > li.is-active ~ li:before {
        background-color: #ECF0F5;
        /*border-color: #888888;*/
    }

    .progress-check {
        position: absolute;
        color: green;
        width: 16px;
        height: 16px;
        top: -3px;
        left: calc(50% + 11px);
        z-index: 1;
    }

    .icon-circle {
        position: absolute;
        width: 20px;
        height: 20px;
        top: 8px;
        left: calc(50% - 10px);
        z-index: 1;
    }

    .multi-steps > li.current {
        color: #266583;

        a {
            color: #266583;
        }
        &:before {
            border-color:#266583 !important;
            background-color: #6496AF31 !important;
        }
    }

</style>